import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { MetricsBar } from '../components/MetricsBar';
import { ExpertiseGrid } from '../components/ExpertiseGrid';
import { CaseStudies } from '../components/CaseStudies';
import { SkillsCloud } from '../components/SkillsCloud';
export function ExpertisePage() {
  return <>
      <PageHeader label="Core Expertise" title="Four pillars, one operating mandate" description="Strategic sourcing, corporate real estate and logistics, risk and continuity, and ESG — each owned end to end across strategy, governance, budget, and team." data-id="element-465" data-mp="2pqceukx44ir7" />
      <MetricsBar data-id="element-466" data-mp="2atdb585dta20" />
      <ExpertiseGrid showLabel={false} data-id="element-467" data-mp="2atv7e4s1no9x" />
      <CaseStudies data-id="element-468" data-mp="2623nue7b2ita" />
      <SkillsCloud data-id="element-469" data-mp="261lmj35sdeei" />
    </>;
}